var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HalfLayout"},[_c('div',{staticClass:"Left"},[(_vm.$slots.header)?_c('div',{staticClass:"Header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"Body",class:{'WithoutBox': _vm.bodyWithOutBox}},[_vm._t("default")],2)]),_c('div',{staticClass:"Right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }